<template>
  <div>
    <OphthalmologyItem :item="item" />
  </div>
</template>

<script>
import OphthalmologyItem from '../item/OphthalmologyItem.vue';

export default {
  props: ['data'],
  components: {
    OphthalmologyItem,
  },
  computed: {
    item() {
      return {
        ...this.data,
        anamnesis: {
          ...this.data.anamnesis,
          inputs: this.data.anamnesis.inputs.reduce((acc, input) => {
            acc[input.name] = input.value;
            return acc;
          }, {}),
        },
      };
    },
  },
};
</script>
